import React from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import PropTypes from 'prop-types'

export default class Internal extends React.Component {
  constructor(props) {
    super(props)

    const emptyPreset = {
      middlewareUrl: '',
      handoverUrl: '',
    }

    this.state = {
      ...emptyPreset,
      ...(this.props.preset || {})
    }
  }

  componentDidMount() {
    this.props.onChange({
      ...this.state,
      backendUrl: this.state.middlewareUrl
    })
  }

  setPreset(preset) {
    this.inputChange(preset)
  }

  inputChange(state) {
    this.setState(state, () => {
      if (this.props.onChange) {
        this.props.onChange({
          ...this.state,
          backendUrl: this.state.middlewareUrl
        })
      }
    })
  }

  render() {
    return (
      <>
        <FormGroup>
          <Label for="middleware-url">Middleware URL</Label>
          <Input
            type="text"
            name="middlewareUrl"
            id="middleware-url"
            placeholder="Middleware Url"
            value={this.state.middlewareUrl}
            onChange={e => this.inputChange({ middlewareUrl: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label for="handover-url">Handover URL</Label>
          <Input
            type="text"
            name="handoverUrl"
            id="handover-url"
            placeholder="Handover Url"
            value={this.state.handoverUrl}
            onChange={e => this.inputChange({ handoverUrl: e.target.value })}
          />
        </FormGroup>
      </>
    )
  }
}

Internal.propTypes = {
  onChange: PropTypes.func,
  preset: PropTypes.shape({
    middlewareUrl: PropTypes.string,
    version: PropTypes.number,
    handoverUrl: PropTypes.string,
  })
}
